import { Box, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { formatDate } from "../../utils/formatDate";


const purchasesColumns = ( handleView, colors) => [
  {
    field: "number",
    headerName: "Número de Factura",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "date",
    headerName: "Creada",
    flex: 1,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "supplier",
    headerName: "Proveedor",
    flex: 1,
  },
  {
    field: "number_of_products",
    headerName: "Productos",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "total_purchase_price",
    headerName: "Costo de Compra",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueFormatter: (value) => `$${value}`,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.4,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
          <VisibilityOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { purchasesColumns }